import { RootState } from 'src/store';

import { IPayoutHistoryItemData, IPayoutOrderListData } from './types';

export const selectPayoutOrdersData = (state: RootState): Partial<IPayoutOrderListData> => state.payoutOrders.list.data;
export const selectPayoutOrdersLoading = (state: RootState): boolean => state.payoutOrders.list.isLoading;
export const selectPayoutOrdersLoaded = (state: RootState): boolean => state.payoutOrders.list.isLoaded;
export const selectPayoutOrderItemData = (state: RootState): Partial<IPayoutHistoryItemData> => state.payoutOrders.item.data;
export const selectPayoutOrderItemLoading = (state: RootState): boolean => state.payoutOrders.item.isLoading;
export const selectPayoutOrderItemLoaded = (state: RootState): boolean => state.payoutOrders.item.isLoaded;
